module.exports = __webpack_public_path__ + "static/14-a104e0e20ceeb7c300e845547c73ff73.jpg";